import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { contentItemAPI } from '../services/api';

const ContentContext = createContext();

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within a ContentProvider');
  }
  return context;
};

/**
 * Sayfa içerik kalemlerini (SSS, "Neden biz", promo şeridi, menü rozetleri)
 * tek istekte çekip bölümlere ayırır.
 *
 * Bileşenler `getSection('faq', FALLBACK)` ile kendi varsayılan listelerini
 * verir; backend erişilemezse veya bölüm boşsa o liste kullanılır, yani sayfa
 * hiçbir koşulda boş bir bölümle render edilmez.
 */
export const ContentProvider = ({ children }) => {
  const [sections, setSections] = useState({});
  const [loading, setLoading] = useState(true);

  const loadItems = useCallback(async () => {
    try {
      const response = await contentItemAPI.getActiveItems();
      const grouped = {};
      (response.data || []).forEach((item) => {
        if (!grouped[item.section]) grouped[item.section] = [];
        grouped[item.section].push(item);
      });
      Object.values(grouped).forEach((list) =>
        list.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
      );
      setSections(grouped);
    } catch (err) {
      console.error('Sayfa içerikleri yüklenirken hata oluştu:', err);
      setSections({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const getSection = useCallback(
    (section, fallback = []) => {
      const items = sections[section];
      return items && items.length > 0 ? items : fallback;
    },
    [sections]
  );

  return (
    <ContentContext.Provider value={{ sections, getSection, loading, refresh: loadItems }}>
      {children}
    </ContentContext.Provider>
  );
};

export default ContentContext;
